export const DEFAULT = {
  searchValueId: '',
  searchValueTitle: '',
  primarySort: 'rank',
  secondarySort: 'subApplicantTitle',
  sort: 'asc',
};

export const SEARCH_DATA_RADIO_BTNS = [
  {
    label: 'Subapplication title',
    value: 'title',
  },
  {
    label: 'Subapplication type',
    value: 'type',
  },
  {
    label: 'Subapplicant',
    value: 'subapplicant',
  },
];

export const SEARCH_DATA_RADIO_BTNS_FOR_AMNDMT = [
  {
    label: 'Subapplication title',
    value: 'title',
  },
  {
    label: 'Subapplication type',
    value: 'type',
  },
];

export const SEARCH_DATA_RADIO_BTNS_FOR_AMNDMT_WITH_EXISTING = [
  {
    label: 'Subapplication title',
    value: 'title',
  },
  {
    label: 'Subapplication type',
    value: 'type',
  },
  {
    label: 'Subgrant ID',
    value: 'subgrant',
  },
];

export const SEARCH_DATA_RADIO_BTNS_FOR_AMNDMT_DISABLED = [
  {
    label: 'Subapplication title',
    value: 'title',
    disabled: true,
  },
  {
    label: 'Subapplication type',
    value: 'type',
    disabled: true,
  },
  {
    label: 'Subgrant ID',
    value: 'subgrant',
  },
];

export const AWARD_RECOMMENDATION_LINK_STATUS_PROGRAMAPPROVED = 'programApproved';
export const AWARD_RECOMMENDATION_LINK_STATUS_GMARCOMPLETE = 'gmarComplete';
export const GMAR_REVIEW_TYPE = 'grantsManagementAwardReview';
export const GMAA_REVIEW_TYPE = 'grantsManagementAwardApproval';

export const SORT_DATA_RADIO_BTNS = [
  {
    label: 'Ascending',
    value: 'asc',
  },
  {
    label: 'Descending',
    value: 'desc',
  },
];

export const SORT_DATA_DROPDOWN = [
  {
    text: 'Rank',
    value: 'rank',
    sort: 'payload.rank',
    path: '',
    key: 'rank',
  },
  {
    text: 'Estimated total duration',
    value: 'estimatedTotalDuration',
    sort: 'payload.schedule.estimatedTotalDuration',
    path: 'payload.schedule',
    key: 'estimatedTotalDuration',
  },
];

export const SUBAPPLICATION_CARD_DETAILS_TITLES = [
  'Subapplicant',
  'Requested federal share amount',
  'Estimated total duration',
  'Subapplication type',
  'Primary action',
  'No. of project sites',
];

export const SUBAPPLICATION_PATHS = {
  rank: 'payload.rank',
  subApplicantTitle: 'subApplicantTitle',
  applicationTitle: 'applicationTitle',
  applicationType: 'subApplicationType',
  fedShare: 'fedShareAmount',
  subAppCategory: 'payload.subApplicationCategory',
};

export const SUBAPPLICATION_RANK_ERROR_MSGS = {
  default: 'A ranking number is required.',
  positiveNumber: 'Ranks must be positive numbers.',
  wholeNumber: 'Ranks must be positive whole numbers.',
  duplicates: 'Cannot have duplicate ranking numbers.',
};

export const SUBTITLES_PATHS = {
  application: 'Application',
  subApplication: 'Sub Application',
  payment: 'Payment',
  amendment: 'Amendment',
  financialReport: 'Financial Report',
  bsirReport: 'Biannual Strategy Implementation Report',
  performanceProgressReport: 'Performance Progress Report',
};
